import React from "react";
interface TabsPropType {
  options: string[];
  components: JSX.Element[];
  activeTab?: number;
  onClickTab?: (index: number) => void;
  fromOffice?: boolean;
  showBottomBorder?: boolean;
}

const Tabs = ({ options = [""], components, activeTab = 0, onClickTab = () => {}, showBottomBorder }: TabsPropType) => {
  return (
    <div className="tabs">
      <div className={`flex justify-between ${showBottomBorder ? "border-b" : ""}`}>
        <div className={`tab-nav flex w-full ${showBottomBorder ? "border-b" : ""}`}>
          {options.map((TabTitle, index) => {
            return (
              <span
                key={index}
                className={`
                text-lg text-center font-bold py-2 -mb-px mr-5 cursor-pointer ${
                  activeTab === index ? "border-b border-docsigna-blue-dark text-docsigna-blue-dark" : "text-docsigna-blue-light"
                }
                `}
                onClick={() => onClickTab(index)}>
                {TabTitle}
              </span>
            );
          })}
        </div>
      </div>
      {components.length && components[activeTab] ? <div className="tab-content py-5">{components[activeTab]}</div> : null}
    </div>
  );
};

export default Tabs;
